import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Descriptions, Modal, Table, Tag, Typography } from 'antd';
import IntlMessage from '../../components/IntlMessage';
import routesApi from '../../api/route';
import { PlusCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const ModalRoute = (props) => {
  const { open, onClose, item, data } = props;
  const [items, setItems] = useState([]);

  // useEffect(() => {
  //   async function fetchData() {
  //     const res = await routesApi.getDestinations(item?.route);
  //     setItems(res);
  //   }

  //   fetchData();
  // }, []);
  const columns = [
    {
      key: 'status',
      title: <IntlMessage id="global.status" />,
      width: 100,
      render: (text, record) => {
        return record?.state === 0 ? (
          <Tag
            color={'#2db7f5'}
            style={{ minWidth: '90px', textAlign: 'center' }}>
            <IntlMessage id={`global.inactive`} />
          </Tag>
        ) : (
          <Tag
            color={'#87d068'}
            style={{ minWidth: '90px', textAlign: 'center' }}>
            <IntlMessage id={`global.active`} />
          </Tag>
        );
      },
    },
    {
      key: 'code',
      title: <IntlMessage id="global.route_code" />,
      fixed: 'left',
      render: (text, record) => {
        return (
          <>
            <Text>
              {record?.start_stop?.title} ~ {record?.end_stop?.title}
            </Text>

            <br />
            <Text>{item?.sku}</Text>
          </>
        );
      },
    },

    {
      key: 'depart_time',
      title: <IntlMessage id="global.depart_time" />,
      render: (text, record) => {
        return record?.start_time;
      },
    },
    {
      key: 'arrival_time',
      title: <IntlMessage id="global.arrival_time" />,
      render: (text, record) => {
        return record?.end_time;
      },
    },
    {
      key: 'arrival_time',
      title: <IntlMessage id="global.current_price" />,
      render: (text, record) => {
        return record?.from_price || 'N/A';
      },
    },
    {
      key: 'code',
      title: <IntlMessage id="global.bus" />,
      render: (text, record) => {
        return (
          <>
            <Text>{item?.seatmap?.title}</Text>
          </>
        );
      },
    },
    {
      key: 'code',
      title: <IntlMessage id="global.bus_type" />,
      render: (text, record) => {
        return <>{item?.seatmap?.status ? '1' : '0'}</>;
      },
    },
    // {
    //   key: 'passenger_yobuma',
    //   title: '#yobuma',
    //   render: (text, record) => {
    //     return formatNumber(record?.pass_yobuma);
    //   },
    // },
    // {
    //   key: 'yobuma',
    //   title: <IntlMessage id="global.yobuma" />,
    //   render: (text, record) => {
    //     return formatCurrency(record?.yobuma);
    //   },
    // },
    // {
    //   key: 'passenger_cashier',
    //   title: '#cashier',
    //   render: (text, record) => {
    //     return formatNumber(record?.pass_cashier);
    //   },
    // },
    // {
    //   key: 'cashier',
    //   title: <IntlMessage id="global.cashier" />,
    //   render: (text, record) => {
    //     return formatCurrency(record?.cashier);
    //   },
    // },
    // {
    //   key: 'total_pass',
    //   title: '#',
    //   render: (text, record) => {
    //     return formatNumber(record?.pass_cashier + record?.pass_yobuma);
    //   },
    // },
    // {
    //   key: 'total',
    //   title: <IntlMessage id="global.total" />,
    //   render: (text, record) => {
    //     return formatCurrency(record?.cashier + record?.yobuma);
    //   },
    // },
    // {
    //   key: 'passengers',
    //   title: <IntlMessage id="global.passengers" />,
    //   render: (text, record) => {
    //     return (
    //       <Button type="link" onClick={() => onModalPass(record)}>
    //         <IntlMessage id="global.passengers" />
    //       </Button>
    //     );
    //   },
    // },
  ];
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={<IntlMessage id="global.route" />}
      width={'100%'}
      className="modal_cashier"
      footer={[
        <Button key={'ok'} type="primary" onClick={onClose}>
          <IntlMessage id="global.ok" />
        </Button>,
      ]}>
      <Table
        dataSource={item?.segments}
        columns={columns}
        tableLayout="auto"
        bordered
        scroll={{ x: 'max-content' }}
        rowKey="id"
        size="small"
      />
    </Modal>
  );
};

ModalRoute.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default ModalRoute;
